import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { SmarticoPromotionLog } from '@core/models/smartico-promotion-log.model';

@Injectable()
export class SmarticoPromotionLogEntityService extends EntityCollectionServiceBase<SmarticoPromotionLog> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('SmarticoPromotionLog', serviceElementsFactory);
    }
}

